import styled from 'styled-components';
import { transparentize } from 'polished';
import colors from '../../theme/colors';

export const ContentWrapperStyled = styled.div`
	position: absolute;
	right: 0;
	width: 50%;
	height: 100%;
	overflow-y: auto;
	padding: 0;
	margin: 0;
	background-color: ${transparentize(0.2, colors.colors.tertiaryColor)};
	color: white;
	z-index: 9;
	padding: ${({ theme }) => theme.variables.padding}px;
	transition: transform 350ms;
	transform: translateX(0%);
	display: flex;
	justify-content: center;
	align-items: center;
	&.closed {
		transform: translateX(100%);
	}
`;

export const CenterContainerStyled = styled.div`
	text-align: center;
`;
